import type { PurchaseOrderDetail } from '../../../services/purchaseOrders';
import { PurchaseOrderLines } from './PurchaseOrderLines';
import { PurchaseOrderZone } from './PurchaseOrderZone';

interface ShippingZoneProps {
    purchaseOrder: PurchaseOrderDetail;
}

// Read-only: shipping is edited from the panel's Actions section, which opens
// the line picker.
export function PurchaseOrderShippingZone({ purchaseOrder }: ShippingZoneProps) {
    return (
        <PurchaseOrderZone
            title="Shipping"
            badge={{ kind: 'fulfillment', status: purchaseOrder.fulfillmentStatus }}
        >
            <PurchaseOrderLines lines={purchaseOrder.lines} canEdit={false} onMarkShipped={noop} />
        </PurchaseOrderZone>
    );
}

function noop(): void {}
